"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gridStyle = exports.verticalStyle = exports.horizontalStyle = void 0;

var tslib_1 = require("tslib");

var styled_components_1 = require("styled-components");

var styles_1 = require("../../styles");

exports.horizontalStyle = styled_components_1.css(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n\t", ";\n\t", ";\n\t> *:not(:last-child) {\n\t\t", ";\n\t}\n"], ["\n\t", ";\n\t", ";\n\t> *:not(:last-child) {\n\t\t", ";\n\t}\n"])), function (_a) {
  var center = _a.center;
  return center && styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n\t\t\tjustify-content: center;\n\t\t"], ["\n\t\t\tjustify-content: center;\n\t\t"])));
}, function (_a) {
  var responsive = _a.responsive;
  return responsive && styled_components_1.css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n\t\t\twidth: 100%;\n\t\t"], ["\n\t\t\twidth: 100%;\n\t\t"])));
}, function (_a) {
  var size = _a.size;
  return styled_components_1.css(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n\t\t\tmargin-right: ", ";\n\t\t"], ["\n\t\t\tmargin-right: ", ";\n\t\t"])), size);
});
exports.verticalStyle = styled_components_1.css(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n\tflex-direction: column;\n\t", ";\n\t", ";\n\t> *:not(:last-child) {\n\t\t", ";\n\t}\n"], ["\n\tflex-direction: column;\n\t", ";\n\t", ";\n\t> *:not(:last-child) {\n\t\t", ";\n\t}\n"])), function (_a) {
  var center = _a.center;
  return center && styled_components_1.css(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n\t\t\talign-items: center;\n\t\t"], ["\n\t\t\talign-items: center;\n\t\t"])));
}, function (_a) {
  var responsive = _a.responsive;
  return responsive && styled_components_1.css(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n\t\t\twidth: 100%;\n\t\t"], ["\n\t\t\twidth: 100%;\n\t\t"])));
}, function (_a) {
  var size = _a.size;
  return styled_components_1.css(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n\t\t\tmargin-bottom: ", ";\n\t\t"], ["\n\t\t\tmargin-bottom: ", ";\n\t\t"])), size);
});
exports.gridStyle = styled_components_1.css(templateObject_12 || (templateObject_12 = tslib_1.__makeTemplateObject(["\n\tflex-wrap: wrap;\n\talign-items: center;\n\t", ";\n\t", ";\n\t", ";\n"], ["\n\tflex-wrap: wrap;\n\talign-items: center;\n\t", ";\n\t", ";\n\t", ";\n"])), function (_a) {
  var responsive = _a.responsive;
  return responsive && styled_components_1.css(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject(["\n\t\t\twidth: 100%;\n\t\t"], ["\n\t\t\twidth: 100%;\n\t\t"])));
}, function (_a) {
  var center = _a.center;
  return center && styled_components_1.css(templateObject_10 || (templateObject_10 = tslib_1.__makeTemplateObject(["\n\t\t\tjustify-content: center;\n\t\t"], ["\n\t\t\tjustify-content: center;\n\t\t"])));
}, function (_a) {
  var size = _a.size;
  return styled_components_1.css(templateObject_11 || (templateObject_11 = tslib_1.__makeTemplateObject(["\n\t\tmargin: calc(-", " / 2);\n\t\t> * {\n\t\t\tmargin: calc(", " / 2);\n\t\t}\n\t"], ["\n\t\tmargin: calc(-", " / 2);\n\t\t> * {\n\t\t\tmargin: calc(", " / 2);\n\t\t}\n\t"])), size, size);
});
var STYLE_MAPPER = {
  horizontal: exports.horizontalStyle,
  vertical: exports.verticalStyle,
  grid: exports.gridStyle
};
var Gap = styles_1.styledWithProps('div', ['size', 'type', 'center', 'responsive'], styled_components_1.css(templateObject_13 || (templateObject_13 = tslib_1.__makeTemplateObject(["\n\t\tdisplay: flex;\n\t\t", ";\n\t"], ["\n\t\tdisplay: flex;\n\t\t", ";\n\t"])), function (_a) {
  var _b = _a.type,
      type = _b === void 0 ? 'horizontal' : _b;
  return STYLE_MAPPER[type];
}));
exports.default = Gap;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;